import { useEffect, useState } from 'react';
import { CheckCircle, WarningCircle, ArrowClockwise } from '@phosphor-icons/react';
import API from '@/lib/api';

export const EpcQrValidation = ({ form, testId }) => {
  const [result, setResult] = useState(null);
  const [retry, setRetry] = useState(0);
  const enabled = !!form.epc_qr_actief;
  const payload = JSON.stringify({
    naam: form.fac_naam || form.bedrijf || form.naam || form.bedrijfsnaam || form.maatschappelijke_naam || '',
    iban: form.iban || '', bic: form.bic || '',
    iban_2: form.iban_2 || '', bic_2: form.bic_2 || '',
    munteenheid: form.munteenheid || 'EUR',
  });

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        const { data } = await API.post('/instellingen/epc-qr-controle', JSON.parse(payload), { signal: controller.signal });
        if (active) setResult({ payload, accounts: data.accounts });
      } catch (error) {
        if (active) setResult({ payload, failed: true });
      }
    }, 350);
    return () => { active = false; clearTimeout(timer); controller.abort(); };
  }, [enabled, payload, retry]);

  if (!enabled) return null;
  if (!result || result.payload !== payload) return (
    <p className="text-xs text-gray-500" role="status" data-testid={`${testId}-loading`}>QR-betaalgegevens worden gecontroleerd…</p>
  );
  if (result.failed) return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-amber-800" role="alert" data-testid={`${testId}-error`}>
      Controle van de QR-betaalgegevens mislukt.
      <button type="button" className="inline-flex items-center gap-1 underline hover:text-amber-950 transition-colors"
        data-testid={`${testId}-retry`} onClick={() => { setResult(null); setRetry(n => n + 1); }}>
        <ArrowClockwise size={14} /> Opnieuw proberen
      </button>
    </div>
  );
  return (
    <div className="space-y-2 text-xs" aria-live="polite" data-testid={testId}>
      {result.accounts.map(account => {
        const Icon = account.valid ? CheckCircle : WarningCircle;
        return <div key={account.key} data-testid={`${testId}-${account.key.replace('_', '-')}`}
          className={`flex items-start gap-2 ${account.valid ? 'text-emerald-800' : 'text-amber-800'}`}>
          <Icon size={16} className="shrink-0 mt-0.5" />
          <span className="min-w-0 break-words"><strong>{account.key === 'iban_2' ? 'IBAN 2' : 'IBAN'}: </strong>
            {account.valid ? 'opmaak en controlegetal geldig.' : `Geen betaal-QR: ${account.error}`}
          </span>
        </div>;
      })}
    </div>
  );
};